import React, { Component } from 'react'
import Grid from "../../../components/grid";
import Portal from "../../../components/portal";
import { AddWageAll } from "./add-wage/AddWageAll";
import { AlertDialog } from "./alert-dialog/alert-dialog";
import { connect } from "react-redux";
import { find } from 'lodash';
import { DeleteWageAction, GetWageAction, AddWageAction, UpdateWageAction, UpdatePerviousDateEmptyAction } from "../../../store/actions/Admin/wage";
import { GetLocationWage } from "../../../store/actions/wage-location";
import Plus_icon from '../../../assets/images/plus_icon.png'
import Edit_icon from '../../../assets/images/edit_icon.png'
import Delete_icon from '../../../assets/images/delete_icon.png'
import './style.scss';
import { format } from "date-fns";

class WageView extends Component {

    state = {
        showWagePopup: false,
        confirmationBox: false,
        alert: false,
        wageRate: [],
        nycList: [],
        counties3List: [],
        stateList: [],
        wageListNYC: [],
        wageList3County: [],
        wageListState: [],
        editData: {},
        columnDefs: [
            { headerName: "Start Date", field: "startDate", sortable: true, filter: true, flex: 1, resizable: true, valueFormatter: params => params.value ? format(new Date(params.value), 'MMM dd yyyy') : "", },
            { headerName: "End Date", field: "endDate", sortable: true, filter: true, flex: 1, resizable: true, valueFormatter: params => params.value ? format(new Date(params.value), 'MMM dd yyyy') : "", },
            { headerName: "Min Wage", field: "minWage", sortable: true, filter: true, flex: 1, resizable: true },
            {
                headerName: "Action", field: "", sortable: false, filter: false, flex: 1,

                cellRenderer: (params) => (
                    <>
                        <div className="action">
                            <button className="btn btn-primary" onClick={() => this.btnEdit(params.data)} ><img src={Edit_icon} /></button>{" "}
                            <button className="btn btn-primary" onClick={() => this.btnDelete(params.data._id)}><img src={Delete_icon} /></button>
                        </div>

                    </>)
            }
        ],
    };

    btnEdit = (params) => {
        if (params.locationId === 'NYC')
            this.setState({ showWagePopup: true, type: params.locationId, editData: params, wageList: this.state.nycList })
        else if (params.locationId === '3 Counties')
            this.setState({ showWagePopup: true, type: params.locationId, editData: params, wageList: this.state.counties3List, })
        else if (params.locationId === 'State')
            this.setState({ showWagePopup: true, type: params.locationId, editData: params, wageList: this.state.stateList })

    }
    btnDelete = async (params) => {
        if (this.state.alert) {
            await this.props.DeleteWageAction(params)
            this.fetchWage().then(r => null);
            this.setState({ confirmationBox: false, alert: false });
        }
        else {
            this.setState({ confirmationBox: true, id: params, alert: true });
        }
    }

    toggleWagePopup = (date) => {
        if (date) {
            this.fetchWage().then(r => null)
        }
        this.setState({ showWagePopup: false })
        document.body.classList.remove('overflow-hidden');
    }
    toggleConfirmationPopup = () => {
        this.setState({ confirmationBox: false })
        document.body.classList.remove('overflow-hidden');
    }


    getLocalTime = (time) => {
        return new Date(time).toLocaleDateString();
    }
    async componentDidMount() {
        await this.props.GetLocationWage();
        this.fetchWage();

    }
    getCountyName = (id) => {

        const obj = find(this.props.wage, { _id: id });
        if (obj) {
            return obj.name;
        }
        return '';
    }

    fetchWage = async () => {

        await this.props.GetWageAction();
        const wageList = this.props.WageReducer.map(wage => {
            let locationId = wage.county.name;
            return { ...wage, locationId };
        });
        let nycList = this.filterWageList(wageList, 'NYC');
        let counties3List = this.filterWageList(wageList, '3 Counties');
        let stateList = this.filterWageList(wageList, 'State');

        this.setState({ nycList, counties3List, stateList });
    };

    filterWageList = (wageList, name) => {
        return wageList.filter(elem => elem.locationId === name);
    };

    render() {
        const { nycList, columnDefs, counties3List, stateList } = this.state;
        return (
            <div>
                <div className="route_page rate_setup_page location-wage">
                    <div className="rates_list">
                        <h4 className="heading_h4">NYC</h4>
                        <div className="list">
                            <Grid
                                rowData={nycList}
                                columnDefs={columnDefs}
                                height="350px">
                            </Grid>
                            <div onClick={() => this.setState({ showWagePopup: true, type: 'NYC', wageList: nycList, editData: {} })} className="df acsa add_rate">
                                <img src={Plus_icon} />
                                <p>Add rate</p>
                            </div>
                        </div>
                    </div>
                    <div className="rates_list">
                        <h4 className="heading_h4">Nassau, Suffolk, Westchester</h4>
                        <div className="list">
                            <Grid
                                //   frameworkComponent={this.frameworkComponents}
                                rowData={counties3List}
                                columnDefs={columnDefs}
                                height="350px">
                            </Grid>

                            <div onClick={() => this.setState({ showWagePopup: true, type: '3 Counties', wageList: counties3List, editData: {} })} className="df acsa add_rate">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlnsXlink="http://www.w3.org/1999/xlink"
                                    version="1.1"
                                    id="Capa_1"
                                    x="0px"
                                    y="0px"
                                    viewBox="0 0 512 512"
                                    // style={{enable:"new 0 0 512 512"}}
                                    xmlSpace="preserve"
                                    width="14px"
                                    height="14px"
                                >
                                    <g>
                                        <g>
                                            <g>
                                                <path
                                                    d="M492,236H276V20c0-11.046-8.954-20-20-20c-11.046,0-20,8.954-20,20v216H20c-11.046,0-20,8.954-20,20s8.954,20,20,20h216    v216c0,11.046,8.954,20,20,20s20-8.954,20-20V276h216c11.046,0,20-8.954,20-20C512,244.954,503.046,236,492,236z"
                                                    data-original="#000000"
                                                    className="active-path"
                                                    data-old_color="#000000"
                                                    fill="rgba(0,0,0,0.5)"
                                                />
                                            </g>
                                        </g>
                                    </g>
                                </svg>
                                <p>Add rate</p>
                            </div>
                        </div>
                    </div>


                    <div className="rates_list">
                        <h4 className="heading_h4">State</h4>

                        <div className="list">
                            <Grid
                                //   frameworkComponent={this.frameworkComponents}
                                rowData={stateList}
                                columnDefs={columnDefs}
                                height="350px">
                            </Grid>

                            <div onClick={() => this.setState({ showWagePopup: true, type: 'State', wageList: stateList, editData: {} })} className="df acsa add_rate">
                                <img src={Plus_icon} alt="" />
                                <p>Add rate</p>
                            </div>
                        </div>
                    </div>


                    {this.state.showWagePopup && (
                        <Portal
                            zIndex="101"
                            height="420px"
                            width="320px"
                            close={this.toggleWagePopup}
                            title={!Object.keys(this.state.editData).length ? 'Add Wage' : 'Edit Wage'} >
                            <AddWageAll
                                id={this.state.locationId}
                                addRate={this.addRate}
                                locations={this.state.locations}
                                isSelected={this.state.type}
                                wageList={this.state.wageList}
                                counties={this.props.WageLocationReducer}
                                user={this.props.user}
                                editData={this.state.editData}
                                close={this.toggleWagePopup}
                                action={this.props}
                            ></AddWageAll>
                        </Portal>
                    )}

                    {this.state.confirmationBox && (
                        <Portal
                            zIndex="101"
                            height="164px"
                            width="424px"
                            close={this.toggleConfirmationPopup}
                            title="Confirmation">
                            <AlertDialog
                                message="Are you sure you want to delete this?"
                                id={this.state.id}
                                alert={this.state.alert}
                                close={this.toggleConfirmationPopup}
                                confirmation={this.btnDelete}
                            >

                            </AlertDialog>
                        </Portal>
                    )}

                </div>
            </div>
        )
    }
}
const mapStateToProps = ({ UserReducer, WageReducer, WageLocationReducer }) => ({ UserReducer, WageReducer, WageLocationReducer });
export default connect(mapStateToProps, { DeleteWageAction, GetWageAction, GetLocationWage, AddWageAction, UpdateWageAction, UpdatePerviousDateEmptyAction })(WageView);
